module.exports = __webpack_public_path__ + "theme/nuclear.css";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/nuclear.bulma
// module id = 236
// module chunks = 0